import { useEffect, useState } from "react";
import axios from "axios";
import { useRazorpay } from "react-razorpay";
import { toast } from "sonner";
import { IndianRupee, X } from "lucide-react";
import { API } from "@/App";
import { waLink } from "@/data/content";

export default function PayButton({ serviceKey, label, amount }) {
  const { Razorpay } = useRazorpay();
  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/csc-services`).then(({ data }) => setEnabled(Boolean(data.payments_enabled))).catch(() => setEnabled(false));
  }, []);

  const pay = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const { data: order } = await axios.post(`${API}/payments/order`, { service_key: serviceKey, name: form.name, phone: form.phone });
      const rzp = new Razorpay({
        key: order.key_id,
        amount: order.amount,
        currency: "INR",
        name: "Bima Bachat Bazar",
        description: order.service_name,
        order_id: order.order_id,
        prefill: { name: form.name, contact: form.phone },
        theme: { color: "#0f52ba" },
        handler: async (res) => {
          try {
            await axios.post(`${API}/payments/verify`, { order_id: res.razorpay_order_id, payment_id: res.razorpay_payment_id, signature: res.razorpay_signature });
            toast.success("Payment successful! Hum WhatsApp par confirm karenge.");
            setOpen(false);
            window.open(waLink(`Namaste, maine ${order.service_name} ka online payment kar diya hai. Mera naam ${form.name} hai.`), "_blank", "noopener,noreferrer");
          } catch {
            toast.error("Payment verify nahi ho paya. Humse WhatsApp par sampark karein.");
          }
        },
      });
      rzp.open();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Payment shuru nahi ho paya.");
    } finally {
      setBusy(false);
    }
  };

  const fallback = () => {
    window.open(waLink(`Namaste Utkarsh ji, mujhe ${label} service chahiye. Kripya process batayein.`), "_blank", "noopener,noreferrer");
  };

  if (!enabled) {
    return (
      <button className="btn btn-primary btn-sm" onClick={fallback} data-testid={`pay-${serviceKey}`}>
        <IndianRupee size={14} /> {label} {amount ? `• ₹${amount}` : ""}
      </button>
    );
  }
  return (
    <>
      <button className="btn btn-primary btn-sm" onClick={() => setOpen(true)} data-testid={`pay-${serviceKey}`}>
        <IndianRupee size={14} /> {label} {amount ? `• ₹${amount}` : ""}
      </button>
      {open && (
        <div className="pay-backdrop" onClick={() => setOpen(false)} data-testid="pay-modal">
          <div className="pay-modal" onClick={(e) => e.stopPropagation()}>
            <button className="pay-close" onClick={() => setOpen(false)} data-testid="pay-modal-close" aria-label="Close"><X size={18} /></button>
            <div className="eyebrow blue">Secure Online Payment</div>
            <h3>{label}</h3>
            <form onSubmit={pay}>
              <label>Your Name<input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="pay-name-input" /></label>
              <label>Mobile Number<input required pattern="[0-9]{10}" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })} data-testid="pay-phone-input" /></label>
              <button className="btn btn-primary btn-block" disabled={busy} data-testid="pay-submit-button">
                {busy ? "Opening payment…" : `Pay ₹${amount} with Razorpay`}
              </button>
            </form>
            <small className="disclaimer">Payment Razorpay ke secure gateway se process hota hai. Receipt WhatsApp par confirm hogi.</small>
          </div>
        </div>
      )}
    </>
  );
}
